import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "./Components/Layout";
import styles from "./styles/Auth.module.css";
import { useAuth } from "./auth/AuthContext";

function useNextParam() {
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const next = sp.get("next") || "/dashboard";
  return next.startsWith("/") ? next : "/dashboard";
}

export default function Login() {
  const nav = useNavigate();
  const next = useNextParam();
  const { login } = useAuth();

  const [name, setName] = useState(""); // username or email
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);

    try {
      await login({
        name: String(name || "").trim(),
        password: String(password || ""),
      });

      nav(next, { replace: true });
    } catch (ex) {
      const msg = ex?.message || "Login failed";
      setErr(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout title="Login - My Chinese Horoscope">
      <div className={styles.card}>
        <h1>MyChineseHoroscope Login</h1>
        <p className={styles.subtitle}>Manage Your Chinese Horoscope.</p>

        <form onSubmit={onSubmit}>
          <div className={styles.field}>
            <label>Username</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              type="text"
              autoComplete="username"
              required
            />
          </div>

          <div className={styles.field}>
            <label>Password</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              autoComplete="current-password"
              required
            />
          </div>

          <div className={styles.actions}>
            <button type="submit" disabled={busy}>
              {busy ? "Signing in..." : "Sign in"}
            </button>
            <Link to="/register">New Register</Link>
          </div>

          <div className={styles.linkRow}>
            <Link to="/forgot-password">Forgot your password?</Link>
          </div>

          {err && <div className={styles.error}>{err}</div>}
        </form>

        <div className={styles.linkRow}>
          <Link to="/">← Back to home</Link>
        </div>
      </div>
    </Layout>
  );
}
